import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {CompliantsClientService} from '@compliants-client/services';
import {log} from '@core/utils';

export const companyConfigGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const compliantsClientService = inject(CompliantsClientService);

  const companyId = route.paramMap.get('companyId') || '';
  if (!companyId) {
    return router.parseUrl('/error');
  }

  const response = await compliantsClientService.getChannelConfig(companyId);
  log.debug('Channel config response:', response);
  if (!response.success || !response.result) {
    return router.parseUrl('/error');
  }

  return true;
};
